module.exports = __webpack_public_path__ + "img/back_button.svg";